import { render, staticRenderFns } from "./boothAgent.vue?vue&type=template&id=236869ea&scoped=true&"
import script from "./boothAgent.vue?vue&type=script&lang=js&"
export * from "./boothAgent.vue?vue&type=script&lang=js&"
import style0 from "./boothAgent.vue?vue&type=style&index=0&id=236869ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236869ea",
  null
  
)

export default component.exports